import { formatDistanceToNow } from 'date-fns';
import { type Locale } from 'date-fns';

export function formatNotificationTimestamp(
  date: Date,
  locale: Locale,
): string {
  const formatted = formatDistanceToNow(date, {
    addSuffix: true,
    locale,
  });
  if (locale.code?.startsWith('en')) {
    return formatted.replace(/^about /, '');
  }
  if (locale.code?.startsWith('fr')) {
    return formatted.replace(/^environ /, '');
  }
  return formatted;
}
